/* unplugin-vue-components disabled */import { render } from "./deposit.vue?vue&type=template&id=62b8ed47"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=62b8ed47&lang=css"

import exportComponent from "D:\\VueDev\\smnc-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__